export default "__VITE_ASSET__cd6c185d__"